import { Accordion, AccordionSummary, AccordionDetails, Typography, Box} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenusJournalier from "./MenusJournalier";
import { useLanguage } from "../../context/LanguageContext";

const ListeMenusJournalier = ({ menus, t, totalContactsPeriodeDominante, ...props }) => {

  const { locale } = useLanguage(); 

  return (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      overflowX: { xs: "visible", md: "auto" },
      gap: 2,
      pb: 1,
      scrollSnapType: { md: "x mandatory" },
      "& > *": {
        scrollSnapAlign: "start"
      }
    }}
  >
    {menus.map((menu) => (
      <Box
        key={menu._id}
        sx={{
          width: { xs: "100%", md: 400 },
          boxSizing: "border-box",
          mx: { xs: "auto", md: 0 },
          flex: { xs: "unset", md: "0 0 auto" },
          borderRadius: 2,
          border: "1px solid #ddd",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          overflow: "hidden",
          p: 2
        }}
      >
        {/* Titre du jour */}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {new Intl.DateTimeFormat(locale, {
            day: "numeric",
            month: "long",
            year: "numeric"
          }).format(new Date(menu.date))}
          {" — "}
          {totalContactsPeriodeDominante} {t("People")}
        </Typography>

        {/* Contenu complet : Imprimer + Matin/Midi/Soir */}
        <MenusJournalier
          info={menu}
          t={t}
          totalContactsPeriodeDominante={totalContactsPeriodeDominante}
          {...props}
        />
      </Box>
    ))}
  </Box>
);

};

export default ListeMenusJournalier;
